import type {
	CmsRouteApiResponse,
	CmsRouteFamily
} from '$models/CmsRoute/CmsRoute';

export function normalizeCmsPublicPath(pathname: string): string {
	let normalizedPath = pathname.trim();

	if (normalizedPath.length === 0) {
		return '/';
	}

	if (!normalizedPath.startsWith('/')) {
		normalizedPath = '/' + normalizedPath;
	}

	if (normalizedPath !== '/' && !normalizedPath.endsWith('/')) {
		normalizedPath += '/';
	}

	return normalizedPath;
}

export function shouldSkipCmsReroutePath(pathname: string): boolean {
	return (
		pathname === '/404' ||
		pathname === '/sitemap.xml' ||
		pathname === '/robots.txt' ||
		pathname === '/api' ||
		pathname.startsWith('/api/') ||
		pathname === '/preview' ||
		pathname.startsWith('/preview/') ||
		pathname === '/__cms' ||
		pathname.startsWith('/__cms/')
	);
}

export function buildInternalCmsPath(family: CmsRouteFamily, publicPath: string): string {
	const normalizedPublicPath = normalizeCmsPublicPath(publicPath);

	if (normalizedPublicPath === '/') {
		return `/__cms/${family}/`;
	}

	return `/__cms/${family}${normalizedPublicPath}`;
}

export async function fetchCmsRouteInternalPath({
	url,
	fetch
}: {
	url: URL;
	fetch: typeof globalThis.fetch;
}): Promise<string | void> {
	if (shouldSkipCmsReroutePath(url.pathname)) {
		return;
	}

	const resolutionUrl = new URL('/api/cms-route', url);
	resolutionUrl.searchParams.set('path', normalizeCmsPublicPath(url.pathname));

	const response = await fetch(resolutionUrl);

	if (!response.ok) {
		return;
	}

	const data = (await response.json()) as CmsRouteApiResponse;

	return data.internalPath ?? undefined;
}
